module.exports = __webpack_public_path__ + "static/media/dailyMirror.398dfb2b.png";